class Registerform extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.email = this.querySelector('[name="customer[email]"]');
        this.confirmEmail = this.querySelector('#RegisterForm-confirm-email');
        this.password = this.querySelector('[name="customer[password]"]');
        this.confirmPassword = this.querySelector('#RegisterForm-password-validate');
        this.firstName = this.querySelector('[name="customer[first_name]"]');
        this.lastName = this.querySelector('[name="customer[last_name]"]');
        this.phone = this.querySelector('#phone-number');
        this.phonePrefix = this.querySelector('#phone-prefix');
        this.birthday = this.querySelector('#MyAccount-dob');
        this.acceptsPolicy = this.querySelector('#accepts-policy');
        this.input_acceptMarketing = this.querySelector('input[name="customer[accepts_marketing]"]');
        this.checkbox_acceptMarketing = this.querySelector('#accepts-marketing');
        this.loyaltyCheckbox = this.querySelector('#accept-loyalty');
        this.smsMarketingCheckbox = this.querySelector('#accept-sms-marketing');
        this.tagsInput = this.querySelector('#tags_value');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.content = this.querySelector(".content_wrapper");
        this.promo = this.querySelector(".custom_success");
        this.submit = this.querySelector("#submit-button");
        this.togglePasswordButton = this.querySelector('#toggle-password');
        this.toggleIcon = this.querySelector('#toggle-icon');
        this.errorSummary = this.querySelector('#error-summary');
    }

    connectedCallback() {
        this.updateMarketingConsent();

        if (this.form) {
            this.form.addEventListener("submit", (e) => this.onSubmit(e));
        }

        if (this.togglePasswordButton) {
            this.togglePasswordButton.addEventListener('click', () => this.togglePasswordVisibility());
        }
        
        // Initialize and handle loyalty checkbox
        if (this.loyaltyCheckbox && this.tagsInput) {
            this.updateLoyaltyTag();
            this.loyaltyCheckbox.addEventListener('change', () => {
                this.updateLoyaltyTag();
                this.updateMarketingConsent();
            });
        }

        if (this.smsMarketingCheckbox) {
            this.smsMarketingCheckbox.addEventListener('change', () => this.updateMarketingConsent());
        }

        //this.checkbox_acceptMarketing.addEventListener("change", this.setInputMarketing.bind(this));

        if (this.formSubmitted()) {
            this.hideForm();
        }
    }

    setInputMarketing(e) {
        this.input_acceptMarketing.value = this.checkbox_acceptMarketing.checked || false;
    }

    updateMarketingConsent() {
        if (!this.input_acceptMarketing) return;

        this.input_acceptMarketing.value = this.loyaltyCheckbox?.checked ? 'true' : 'false';
    }

    normalizeSmsPhoneNumber() {
        if (!this.phone?.value.trim()) return '';

        const rawPhone = this.phone.value.trim();
        const digits = rawPhone.replace(/\D/g, '');
        const selectedPrefix = this.phonePrefix?.value || '+1';
        const prefixDigits = selectedPrefix.replace(/\D/g, '');
        const isValidNanpNumber = (number) => /^[2-9]\d{2}[2-9]\d{6}$/.test(number);

        if (rawPhone.startsWith('+')) {
            if (digits.startsWith('1')) {
                return digits.length === 11 && isValidNanpNumber(digits.slice(1)) ? `+${digits}` : '';
            }

            return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : '';
        }

        if (selectedPrefix === '+1') {
            if (digits.length === 10 && isValidNanpNumber(digits)) return `+1${digits}`;
            if (digits.length === 11 && digits.startsWith('1') && isValidNanpNumber(digits.slice(1))) return `+${digits}`;

            return '';
        }

        const localDigits = digits.startsWith(prefixDigits) ? digits.slice(prefixDigits.length) : digits;
        const internationalDigits = `${prefixDigits}${localDigits}`;
        if (localDigits.length >= 4 && internationalDigits.length >= 8 && internationalDigits.length <= 15) {
            return `+${internationalDigits}`;
        }

        return '';
    }

    formSubmitted() {
        const params = new URLSearchParams(window.location.search);
        return params.get("customer_posted") === "true";
    }

    hideForm() {
        this.content.style.display = "none";
    }

    showPromo() {
        this.promo.style.display = "flex";
    }

    hideMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "none";
        }
    }
    
    updateLoyaltyTag() {
        if (!this.loyaltyCheckbox || !this.tagsInput) return;
        
        
        const tags = (this.tagsInput.value || '')
            .split(',')
            .map(tag => tag.trim())
            .filter(tag => tag && tag !== 'yotpo_optin');
        
        // Add the tag if checkbox is checked
        if (this.loyaltyCheckbox.checked) {
            tags.push('yotpo_optin');
        }
        
        // Update the input value
        this.tagsInput.value = tags.join(',');
    }

    updateSmsPhoneTag(phone) {
        if (!this.tagsInput) return;

        const tags = (this.tagsInput.value || '')
            .split(',')
            .map(tag => tag.trim())
            .filter(tag => tag && !tag.startsWith('phone:'));

        if (this.smsMarketingCheckbox?.checked && phone) {
            tags.push(`phone:${phone}`);
        }

        this.tagsInput.value = tags.join(',');
    }

    showMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "flex";
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    showErrorIcon(field) {
        const errorIcon = field.parentElement.querySelector('.error-icon');
        if (errorIcon) {
            errorIcon.style.display = 'block';
        }
    }

    updateErrorSummary(errors) {
        if (errors.length > 0) {

            this.errorSummary.innerHTML = `
                <ul class="visually-hidden">
                    ${errors.map(error => `<li>${error}</li>`).join('')}
                </ul>
            `;
            this.errorSummary.classList.remove('visually-hidden');
            this.errorSummary.setAttribute('role', 'alert');
            this.errorSummary.focus();
        } else {
            this.errorSummary.classList.add('visually-hidden');
            this.errorSummary.innerHTML = '';
        }
    }

    onSubmit(e) {
        e.preventDefault();
        this.hideMailError();
        
        // Ensure loyalty tag is set correctly before submission
        if (this.loyaltyCheckbox && this.tagsInput) {
            this.updateLoyaltyTag();
        }

        this.updateMarketingConsent();

        let isValid = true;
        let errors = [];

        this.querySelectorAll('.error-message').forEach(el => el.textContent = '');
        this.querySelectorAll('.field').forEach(el => {
            el.classList.remove('error-border');
            el.querySelector("input")?.removeAttribute("aria-invalid");
            el.querySelector(".error-icon").style.display = 'none';
        });

        if (!this.firstName.value.trim()) {
            isValid = false;
            const errorFN = this.querySelector('#first-name-error');
            errorFN.textContent = errorFN.dataset.errorMessage;
            this.firstName.closest('.field').classList.add('error-border');
            this.firstName.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.firstName);
            errors.push(errorFN.dataset.errorMessage);
        }

        if (!this.lastName.value.trim()) {
            isValid = false;
            const errorLN = this.querySelector('#last-name-error');
            errorLN.textContent = errorLN.dataset.errorMessage;
            this.lastName.closest('.field').classList.add('error-border');
            this.lastName.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.lastName);
            errors.push(errorLN.dataset.errorMessage);
        }

        const errorEM = this.querySelector('#email-error');
        if (!this.email.value.trim()) {
            isValid = false;
            errorEM.textContent = errorEM.dataset.errorMessage;
            this.email.closest('.field').classList.add('error-border');
            this.email.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.email);
            errors.push(errorEM.dataset.errorMessage);
        } else if (!this.isValidEmail(this.email.value.trim())) {
            isValid = false;
            errorEM.textContent = errorEM.dataset.errorMessage;
            this.email.closest('.field').classList.add('error-border');
            this.email.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.email);
            errors.push(errorEM.dataset.errorMessage);
        } else if (this.email.value.trim() !== this.confirmEmail.value.trim()) {
            isValid = false;
            const errorREEM = this.querySelector('#confirm-email-error');
            errorREEM.textContent = errorREEM.dataset.errorMessage;
            this.confirmEmail.closest('.field').classList.add('error-border');
            this.email.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.confirmEmail);
            errors.push(errorREEM.dataset.errorMessage);
        }

        if (!this.birthday.value.trim()) {
            isValid = false;
            const errorBI = this.querySelector('#birthday-error');
            errorBI.textContent = errorBI.dataset.errorMessage;
            this.birthday.closest('.field').classList.add('error-border');
            this.birthday.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.birthday);
            errors.push(errorBI.dataset.errorMessage);
        }

        const hasPhoneValue = !!this.phone?.value.trim();
        const normalizedPhone = hasPhoneValue ? this.normalizeSmsPhoneNumber() : '';
        if ((this.smsMarketingCheckbox?.checked || hasPhoneValue) && !normalizedPhone) {
            isValid = false;
            const errorPH = this.querySelector('#phone-error');
            errorPH.textContent = errorPH.dataset.errorMessage;
            this.phone.closest('.field').classList.add('error-border');
            this.phone.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.phone);
            errors.push(errorPH.dataset.errorMessage);
        } else if (normalizedPhone) {
            this.phone.value = normalizedPhone;
        }

        this.updateSmsPhoneTag(this.smsMarketingCheckbox?.checked ? normalizedPhone : '');

        const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
        const errorPSW = this.querySelector('#password-error');
        if (!this.password.value.trim()) {
            isValid = false;
            errorPSW.textContent = errorPSW.dataset.errorMessage;
            this.password.closest('.field').classList.add('error-border');
            this.password.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.password);
            errors.push(errorPSW.dataset.errorMessage);
        } else if (!passwordRegex.test(this.password.value.trim())) {
            isValid = false;
            errorPSW.textContent = errorPSW.dataset.errorMessageRequired;
            this.password.closest('.field').classList.add('error-border');
            this.password.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.password);
            errors.push(errorPSW.dataset.errorMessageRequired);
        }

        if (!this.confirmPassword.value.trim()) {
            isValid = false;
            const errorPSWCO = this.querySelector('#confirm-password-error');
            errorPSWCO.textContent = errorPSWCO.dataset.errorMessage;
            errorPSWCO.style.display = 'block';
            errorPSWCO.classList.remove('visually-hidden');
            this.confirmPassword.closest('.field').classList.add('error-border');
            this.confirmPassword.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.confirmPassword);
            errors.push(errorPSWCO.dataset.errorMessage);
        } else if (this.password.value.trim() !== this.confirmPassword.value.trim()) {
            isValid = false;
            const errorPSWCO = this.querySelector('#confirm-password-error');
            errorPSWCO.textContent = errorPSWCO.dataset.errorMessage;
            errorPSWCO.style.display = 'block';
            errorPSWCO.classList.remove('visually-hidden');
            this.confirmPassword.closest('.field').classList.add('error-border');
            this.confirmPassword.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.confirmPassword);
            errors.push(errorPSWCO.dataset.errorMessage);
        }

        if (!this.acceptsPolicy.checked) {
            isValid = false;
            const errorPO = this.querySelector('#policy-error');
            errorPO.textContent = errorPO.dataset.errorMessage;
            this.acceptsPolicy.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.acceptsPolicy);
            errors.push(errorPO.dataset.errorMessage);
        }

        this.updateErrorSummary(errors);

        if (isValid) {
            
            try {
                // Mark as new account so registration event can create token
                localStorage.setItem('is-account-new', 'true');
            } catch (err) {
                console.error('[REA][registerForm] ✗ Step 1/4 FAILED: localStorage unavailable:', err);
            }

            // Persist storefront config if present on the page
            const storefrontToken = document.getElementById('storefront-access-token')?.value;
            const storefrontEndpoint = document.getElementById('storefront-endpoint')?.value;
            
            if (storefrontToken) {
                localStorage.setItem('storefrontToken', storefrontToken);
            } else {
                console.warn('[REA][registerForm] ⚠ Step 2/4a: No storefrontToken found in DOM');
            }
            
            if (storefrontEndpoint) {
                localStorage.setItem('storefrontEndpoint', storefrontEndpoint);
            } else {
                console.warn('[REA][registerForm] ⚠ Step 2/4b: No storefrontEndpoint found in DOM');
            }

            // Save encoded customer profile (email + password) to localStorage as c_profile
            try {
                const email = this.email.value.trim();
                const password = this.password.value.trim();
                
                const dataObj = [{ e: email, p: password }];
                const jsonString = JSON.stringify(dataObj);
                
                const encodedString = btoa(jsonString);
                
                localStorage.setItem('c_profile', encodedString);
                
                // Verify immediately
                const verified = localStorage.getItem('c_profile');
            } catch (err) {
                console.error('[REA][registerForm] ✗ Step 3/4 FAILED: Could not save c_profile:', err);
            }
            
            this.querySelector('form').submit();
        }
    }
}

customElements.define("register-form", Registerform);